import React, { useEffect } from 'react'

import {
  api,
  clearAllAuthValues,
  SplashContainer,
} from '../internal';
import { useAuth } from 'react-oidc-context';

interface IProps {
  match: any,
  history: any,
}

const OidcLogoutContainer: React.FC<IProps> = (props) => {
  const auth = useAuth();

  useEffect(() => {
    const continueHashFromCache = api.cacheImpl.get('continueTo');
    // clear values
    auth.removeUser();
    clearAllAuthValues();
    // reset for return & redirect
    if (continueHashFromCache !== null && continueHashFromCache !== 'null') {
      api.cacheImpl.set('continueTo', continueHashFromCache);
    }
    

  }, []);

  return (
    <SplashContainer
      fromComponentName="oidclogout"
      match={props.match}
      history={props.history}
      externalRedirect={true} />
  )
}

export default OidcLogoutContainer;
